import { r as registerInstance, h, F as Fragment } from './index-5faac9d7.js';
import { i as isEmpty_1 } from './isEmpty-ea893565.js';
import { X as SUBCATEGORY } from './currency-49e0d692.js';
import './product-card-78a466f2.js';
import { s as store } from './pes-router-store-498d2799.js';
import './store-a2f488b2.js';
import './index-39f51a91.js';
import { a as addHostToHmcUrls } from './utils-f0ef036b.js';
import './_nodeUtil-549406aa.js';
import './_commonjsHelpers-7db8bc26.js';
import './pick-8e119733.js';
import './_basePickBy-19dc1369.js';
import './_arrayLikeKeys-26c55d84.js';
import './isSymbol-8fefec05.js';
import './_Stack-cf94d4e7.js';
import './toString-568546f3.js';
import './_isIndex-3036d479.js';
import './keysIn-b6895676.js';
import './hasIn-833a7ad2.js';
import './_flatRest-cc9038d0.js';
import './_baseFlatten-eecfdcde.js';
import './index-43880fda.js';
import './pes-product-link-74e48119.js';
import './utils-cdf9de4e.js';
import './analytics-b3108572.js';
import './helpers-cd261aee.js';
import './tslib.es6-613ce1cd.js';
import './navigation-83d2f79a.js';
import './toNumber-d92ee08f.js';
import './index-67820103.js';
import './utils-2fbd0743.js';
import './_baseFor-a28737de.js';
import './_copyObject-3791899f.js';
import './constants-7d3b1dc0.js';
import './number-fcf5283d.js';
import './analytics-74fe4f64.js';
import './utils-1b416b6b.js';
import './utils-6c8f178b.js';
import './index-54dd34b7.js';
import './lodash-7f024380.js';

const pesAppSubcategoryCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.hmc-banner-container{display:block;margin:0 auto;padding:0 16px 20px;box-sizing:border-box;max-width:1200px;overflow:visible;color:#626469;margin-top:42px;padding-bottom:0}.hmc-banner-container *,.hmc-banner-container *::before,.hmc-banner-container *::after{box-sizing:inherit}@media screen and (min-width: 980px){.hmc-banner-container{padding:0 10px}}@media screen and (min-width: 980px){.hmc-banner-container{margin-top:48px}}.subcategories__main{background-color:#fafafa}";

const PesAppSubcategory = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = undefined;
    this.subcategoryId = undefined;
    this.showBreadcrumbs = undefined;
    this.subcategoryData = null;
    this.recentlyViewedProducts = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.hostWithLocale = '';
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
  }
  componentWillLoad() {
    this.hostWithLocale = `${this.host}${this.countryCode}/${this.languageCode}/`;
  }
  get customBreadcrumbs() {
    var _a, _b;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return {
      breadcrumbs: this.subcategoryData
        && ((_b = (_a = this.subcategoryData.subcategoryBreadcrumbs) === null || _a === void 0 ? void 0 : _a.breadcrumbs) === null || _b === void 0 ? void 0 : _b.filter((breadcrumb) => {
          return !['SITE', 'BUSINESS'].includes(breadcrumb.itemType);
        })),
    };
  }
  get hmcBanner() {
    var _a;
    if (!((_a = this.subcategoryData) === null || _a === void 0 ? void 0 : _a.hmcBanner)) {
      return {};
    }
    const { hmcBanner } = this.subcategoryData;
    addHostToHmcUrls(this.host, hmcBanner);
    return hmcBanner;
  }
  render() {
    const { subcategoryBreadcrumbs: { hideOnMobile }, subcategoryDescription: { name, description, readLessLabel, readMoreLabel }, subcategoryRanges: { rangePartofLabel, rangeProductsViewDetailsLabel, productRelationsViewProdLabel, viewOnLabel, ranges, subCatagoryProductRangeLabel, avoidAccents, }, } = this.subcategoryData;
    const { sourceId, categoryName, parentCategoryId, hasQuestionnaire, categoryProductConfiguratorUrl, questionnaireUrl, rangeTooltipUrl, selectorConfigUrl, labels, } = this.hmcBanner;
    return (h(Fragment, null, h("div", { class: "subcategories__main" }, this.showBreadcrumbs && (h("pes-breadcrumbs", Object.assign({}, this.customBreadcrumbs, { hideOnMobile: hideOnMobile, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs", hostWithLocale: this.hostWithLocale }))), h("header", null, h("pes-category-description", { name: name, description: description, readMoreLabel: readMoreLabel, readLessLabel: readLessLabel })), h("main", null, !isEmpty_1(this.hmcBanner) && (h("div", { class: "hmc-banner-container" }, h("pes-hmc-banner", { sourceId: sourceId, categoryName: categoryName, parentCategoryId: parentCategoryId, hasQuestionnaire: hasQuestionnaire, categoryProductConfiguratorUrl: categoryProductConfiguratorUrl, questionnaireUrl: questionnaireUrl, rangeTooltipUrl: rangeTooltipUrl, selectorConfigUrl: selectorConfigUrl, labels: labels, isPBS: true }))), h("pes-category-range-list", { rangePartofLabel: rangePartofLabel, rangeProductsViewDetailsLabel: rangeProductsViewDetailsLabel, productRelationsViewProdLabel: productRelationsViewProdLabel, viewOnLabel: viewOnLabel, ranges: ranges, subCatagoryProductRangeLabel: subCatagoryProductRangeLabel, avoidAccents: avoidAccents, hostWithLocale: this.hostWithLocale, subcategoryId: this.subcategoryId }), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { class: "pes-app-subcategory__section", hostWithLocale: this.hostWithLocale, pageId: this.subcategoryId, pageType: SUBCATEGORY }))))));
  }
};
PesAppSubcategory.style = pesAppSubcategoryCss;

export { PesAppSubcategory as pes_app_subcategory };
